import { liveUpdateAttrs } from 'libs/contentful/utils';
import RichTextCopy from 'components/shared/RichTextCopy/RichTextCopy';
import RichTextHeadline from 'components/shared/RichTextHeadline/RichTextHeadline';

import Eyebrow from 'components/shared/Eyebrow/Eyebrow';
import CTA, { isValidCta } from 'components/shared/CTA/CTA';

import { ContentBlockAlignment, TwoColumnVariantProps } from './types';

import { cn } from 'utils/styles';

const TwoColumnVariant = ({
  sys,
  eyebrow,
  eyebrowAlternateLogo,
  eyebrowChimeLogo,
  headline,
  copy,
  cta,
  alignment,
  className,
}: TwoColumnVariantProps) => {
  const internalClassNames = {
    wrapper: cn('flex flex-col sm:grid sm:grid-cols-2 gap-12 justify-between', className?.wrapper),
    headline: {
      wrapper: cn(
        'flex flex-col gap-2',
        { 'sm:order-1': alignment === ContentBlockAlignment.Right },
        className?.headline?.wrapper,
      ),
      content: cn(
        'text-heading-md sm:text-heading-lg font-sans grid grid-cols-[1fr_3rem]',
        className?.headline?.content,
      ),
    },
    content: cn(
      'flex flex-col gap-4 justify-between font-serif text-lg',
      {
        'sm:order-0': alignment === ContentBlockAlignment.Right,
      },
      className?.content,
    ),
  };

  const headlineTestId = `headline-${alignment === ContentBlockAlignment.Left ? 'left' : 'right'}`;
  const copyTestId = `copy-${alignment === ContentBlockAlignment.Left ? 'right' : 'left'}`;

  return (
    <div className={internalClassNames.wrapper}>
      <div className={internalClassNames.headline.wrapper} data-testid={headlineTestId}>
        <Eyebrow
          sys={sys}
          eyebrowAlternateLogo={eyebrowAlternateLogo}
          eyebrowChimeLogo={eyebrowChimeLogo}
          eyebrowText={eyebrow}
          className="mb-0"
        />
        <div className={internalClassNames.headline.content} {...liveUpdateAttrs(sys?.id, 'headline')}>
          <RichTextHeadline headline={headline} level="h2" />
        </div>
      </div>

      <div className={internalClassNames.content} data-testid={copyTestId}>
        <div {...liveUpdateAttrs(sys?.id, 'copy')}>
          <RichTextCopy copy={copy} />
        </div>
        {isValidCta(cta) && <CTA cta={cta} />}
      </div>
    </div>
  );
};

export default TwoColumnVariant;
